export default {
    "/hub": { page: "Hub", name: 'Hub', auth: true },
    "/settings": { page: "Settings", name: 'Settings', auth: true },
    "/pricing": { page: "Pricing", name: 'Pricing', auth: false },
    "/billing/success": { page: "BillingSuccess", name: 'Billing Success', auth: true },
    "/": { page: "commerce/Landing", name: 'Menu', auth: false },
    "/product/:id": { page: "commerce/Product", name: 'View Product', auth: false },
    "/products": { page: "commerce/ViewProducts", name: 'Products', auth: false },
    "/products/:category": { page: "commerce/Products", name: 'Products', auth: false },
    "/weed-delivery-rawai": { page: "commerce/WeedDeliveryRawai", name: 'Weed Delivery Rawai', auth: false },
    "/weed-shop-rawai": { page: "commerce/WeedShopRawai", name: 'Weed Shop Rawai', auth: false },
    "/weed-delivery-phuket": { page: "commerce/WeedDeliveryPhuket", name: 'Weed Delivery Phuket', auth: false },
    "/about": { page: "About", name: 'About', auth: false },
    "/find-us": { page: "FindUs", name: 'Find Us', auth: false },
    "/blog": { page: "blog/Blog", name: 'Blog', auth: false },
    "/blog/:slug": { page: "blog/Post", name: 'Blog Post', auth: false },
    "/cart": { page: "commerce/Cart", name: 'View Cart', auth: false },
    "/checkout": { page: "commerce/Checkout", name: 'View Checkout', auth: false },
    "/payment": { page: "commerce/Payment", name: 'View Payment', auth: false },
    "/confirmation": { page: "commerce/Confirmation", name: 'View Confirmation', auth: false },

    "/login": { page: "auth/Login", name: 'Log In', auth: false },
    "/signup": { page: "auth/Signup", name: 'Sign Up', auth: false },
    "/logout": { page: "auth/Logout", name: 'Logout', auth: false },
    "/auth-bridge": { page: "auth/AuthBridge", name: "Auth Bridge", auth: false },
    "/auth/link-tv": { page: "auth/LinkTv", name: "Link TV", auth: false },
    "/invite/:token": { page: "auth/Invite", name: 'Accept Invitation', auth: false },
    "/404": { page: "auth/404", name: '404', auth: false },
    "/permission-denied": { page: "auth/NoPermission", name: 'NoPermission', auth: false },

    "/race": { page: "Race", name: 'Jungle Kart', auth: false },

    "/pos": { page: "Pos", name: 'POS', auth: true },
    "/pos-settings": { page: "pos/PosSettings", name: 'POS Settings', auth: true },
    "/chat": { page: "Chat", name: 'Chat', auth: false },
    "/shifts": { page: "pos/Shifts", name: 'Shifts', auth: true },
    "/schedule": { page: "Schedule", name: 'Team Schedule', auth: true },
    "/team-portal": { page: "StaffPortal", name: 'Team Portal', auth: true },
    "/staff-portal": { page: "StaffPortal", name: 'Team Portal', auth: true }, // legacy alias — keep old links/QR working
    "/sale-history": { page: "pos/SaleHistory", name: 'Sale History', auth: true },
    "/unpaid-orders": { page: "pos/UnpaidOrders", name: 'Unpaid Orders', auth: true },
    "/pending-orders": { page: "pos/PendingOrders", name: 'Pending Orders', auth: true },
    "/transfer": { page: "Transfer", name: 'Transfer', auth: false },
    "/tv": { page: "tv/Tv", name: 'TV', auth: false },
    "/tv-menu": { page: "tv/Tv", name: 'TV Menu', auth: false },
    "/menu": { page: "tv/Cata", name: 'Menu', auth: false },
    "/promo": { page: "Promo", name: 'Promo', auth: false },
    "/logo": { page: "Logo", name: 'Logo', auth: false },
    "/label": { page: "Print", name: 'label', auth: false },
    "/print": { page: "Print", name: 'Print Restrictions', auth: false },
    "/strength/:level": { page: "Print", name: 'label', auth: false },
    "/cata": { page: "tv/Cata", name: 'Cata', auth: false },
    "/drinks": { page: "tv/Drinks", name: 'Cata', auth: false },
    "/client": { page: "Client", name: 'Client', auth: true },
    "/bestsellers": { page: "tv/BestSellers", name: 'Best Sellers', auth: false },
    "/shelves": { page: "tv/Shelves", name: 'Shelves', auth: false },
    "/all": { page: "tv/All", name: 'All', auth: false },

    "/receipt/:id": { page: "commerce/Receipt", name: 'View Receipt', auth: false },
    "/customer/:id": { page: "CustomerProfile", name: 'My Jungle Profile', auth: false },
    "/account": { page: "CustomerAccount", name: 'My Account', auth: true },
    "/label/:id": { page: "Label", name: 'View Label', auth: true },
    "/printer": { page: "admin/LabelMaker", name: 'Label Maker', auth: true },
    "/nfc": { page: "NFC", name: 'NFC', auth: true },
    "/members": { page: "pos/Members", name: 'Members', auth: true },
    "/delivery": { page: "pos/Delivery", name: 'Delivery', auth: true },
    "/viewDelivery/:id": { page: "pos/ViewDelivery", name: 'Delivery', auth: true },
    "/restock": { page: "pos/Restock", name: 'Restock Flower', auth: true },
    "/restock-inventory": { page: "pos/RestockInventory", name: 'Restock Inventory', auth: true },
    "/restock-list": { page: "pos/RestockList", name: 'Restock List', auth: true },
    "/upload-photo/:id": { page: "pos/UploadPhoto", name: 'Upload Strain Photo', auth: false },


    //Admin
    "/admin": { page: "admin/Dashboard", name: 'Dashboard', auth: true },
    "/admin/performance": { page: "admin/Performance", name: 'Performance', auth: true },
    "/admin/team": { page: "admin/Team", name: 'Team Management', auth: true, role: 'admin' },
    "/admin/label": { page: "admin/LabelMaker", name: 'View Label', auth: true },
    "/admin/accounting": { page: "admin/Accounting", name: 'Accounting', auth: true },
    "/admin/calendar": { page: "admin/calendar/Calendar", name: 'Calendar', auth: true, role: 'admin' },
    "/admin/calendar/costs": { page: "admin/calendar/CostSummary", name: 'Cost Summary', auth: true, role: 'admin' },
    "/admin/security": { page: "admin/Security", name: 'Security Dashboard', auth: true, role: 'admin' },
    "/admin/alerts": { page: "admin/Alerts", name: 'Alerts', auth: true, role: 'admin' },
    "/admin/realtime": { page: "admin/realtime/Realtime", name: 'Realtime', auth: true, role: 'admin' },
    "/admin/realtime/camera": { page: "admin/realtime/Camera", name: 'Shop Camera', auth: true },
    "/admin/cctv": { page: "admin/realtime/Cctv", name: 'POS CCTV', auth: true, role: 'admin' },
    "/admin/watch": { page: "admin/watch/Watch", name: 'Watch', auth: true, role: 'admin' },
    "/admin/watch/camera": { page: "admin/watch/WatchCamera", name: 'Watch Camera', auth: true },
    "/admin/certificate": { page: "admin/Certificate", name: 'Medical Certificate', auth: true },
    "/admin/certificate/report": { page: "admin/CertificateReport", name: 'Monthly Report', auth: true },
    "/admin/whatsapp": { page: "admin/whatsapp/WhatsappDashboard", name: 'WhatsApp', auth: true, role: 'admin' },
    "/admin/age-verifications": { page: "admin/AgeVerifications", name: 'Age Checks', auth: true, role: 'admin' },

    //Inventory
    "/admin/inventory/add": { page: "admin/inventory/ModifyInventory", name: 'Add Inventory', auth: true },
    "/admin/inventory/view": { page: "admin/inventory/ViewInventory", name: 'View Inventory', auth: true },
    "/admin/inventory/analytics": { page: "admin/inventory/InventoryAnalytics", name: 'Inventory Analytics', auth: true },
    "/admin/inventory/restock": { page: "admin/inventory/InventoryAnalytics", name: 'Inventory Restock', auth: true },
    "/admin/inventory/edit/:id": { page: "admin/inventory/ModifyInventory", name: 'Edit Inventory', auth: true },
    "/admin/inventory/restock-history": { page: "admin/inventory/InventoryRestockHistory", name: 'Inventory Restock History', auth: true },
    "/admin/inventory-scanner": { page: "admin/inventory/InventoryScanner", name: 'Inventory Scanner', auth: true },
    "/script": { page: "admin/inventory/InventoryDescriptionScript", name: 'Inventory Description Script', auth: true },
    "/script-image": { page: "admin/inventory/InventoryImageScript", name: 'Inventory Image Background Script', auth: true },
    "/inventory": { page: "pos/RestockInventory", name: 'Add Inventory', auth: false },

    //Strains
    "/admin/strains/add": { page: "admin/strains/ModifyStrains", name: 'Add Strains', auth: true },
    "/admin/strains/view": { page: "admin/strains/ViewStrains", name: 'View Strains', auth: true },
    "/admin/strains/edit/:id": { page: "admin/strains/ModifyStrains", name: 'Edit Strains', auth: true },
    "/admin/strains/restock-history": { page: "admin/strains/StrainRestockHistory", name: 'Strain Restock History', auth: true },
    "/compliant": { page: "admin/strains/CompliantStrains", name: 'Compliant Strains', auth: true },

    //Delivery
    "/admin/delivery/add": { page: "admin/delivery/ModifyDelivery", name: 'Add Delivery', auth: true },
    "/admin/delivery/view": { page: "admin/delivery/ViewDelivery", name: 'View Delivery', auth: true },
    "/admin/delivery/edit/:id": { page: "admin/delivery/ModifyDelivery", name: 'Edit Delivery', auth: true },

    //Suppliers
    "/admin/suppliers/add": { page: "admin/suppliers/ModifySuppliers", name: 'Add Supplier', auth: true },
    "/admin/suppliers/view": { page: "admin/suppliers/ViewSuppliers", name: 'View Supplier', auth: true },
    "/admin/suppliers/edit/:id": { page: "admin/suppliers/ModifySuppliers", name: 'Edit Supplier', auth: true },

    //Orders
    "/admin/orders/add": { page: "admin/orders/ModifyOrders", name: 'Add Orders', auth: true },
    "/admin/orders/view": { page: "admin/orders/ViewOrders", name: 'View Orders', auth: true },
    "/admin/orders/edit/:id": { page: "admin/orders/ModifyOrders", name: 'Edit Orders', auth: true },

    //Sales
    "/admin/sales/add": { page: "admin/sales/ModifySales", name: 'Add Sales', auth: true },
    "/admin/sales/view": { page: "admin/sales/ViewSales", name: 'View Sales', auth: true },
    "/admin/sales/edit/:id": { page: "admin/sales/ModifySales", name: 'Edit Sales', auth: true },

    //Shifts
    "/admin/shifts/add": { page: "admin/shifts/ModifyShifts", name: 'Add Shifts', auth: true },
    "/admin/shifts/view": { page: "admin/Team", name: 'Shifts', auth: true, role: 'admin' },
    "/admin/shifts/edit/:id": { page: "admin/shifts/ModifyShifts", name: 'Edit Shifts', auth: true },

    //Expenses
    "/admin/expenses/add": { page: "admin/expenses/ModifyExpenses", name: 'Add Expenses', auth: true },
    "/admin/expenses/view": { page: "admin/expenses/ViewExpenses", name: 'View Expenses', auth: true },
    "/admin/expenses/edit/:id": { page: "admin/expenses/ModifyExpenses", name: 'Edit Expenses', auth: true },

    //Customers
    "/admin/customers/add": { page: "admin/customers/ModifyCustomers", name: 'Add Customers', auth: true },
    "/admin/customers/view": { page: "admin/customers/ViewCustomers", name: 'View Customers', auth: true },
    "/admin/customers/merge": { page: "admin/customers/MergeCustomers", name: 'Merge Customers', auth: true },
    "/admin/customers/edit/:id": { page: "admin/customers/ModifyCustomers", name: 'Edit Customers', auth: true },

    //Promotions
    "/admin/promotions/add": { page: "admin/promotions/ModifyPromotions", name: 'Add Promotions', auth: true },
    "/admin/promotions/view": { page: "admin/promotions/ViewPromotions", name: 'View Promotions', auth: true },
    "/admin/promotions/edit/:id": { page: "admin/promotions/ModifyPromotions", name: 'Edit Promotions', auth: true },

    //Restock Flower
    "/admin/restock-flower/add": { page: "admin/restock-flower/ModifyRestockFlower", name: 'Add Restock Flower', auth: true },
    "/admin/restock-flower/view": { page: "admin/strains/StrainRestockHistory", name: 'Strain Restock History', auth: true },
    "/admin/restock-flower/edit/:id": { page: "admin/restock-flower/ModifyRestockFlower", name: 'Edit Restock Flower', auth: true },

    //Restock Inventory
    "/admin/restock-inventory/add": { page: "admin/restock-inventory/ModifyRestockInventory", name: 'Add Restock Inventory', auth: true },
    "/admin/restock-inventory/view": { page: "admin/inventory/InventoryRestockHistory", name: 'Inventory Restock History', auth: true },
    "/admin/restock-inventory/edit/:id": { page: "admin/restock-inventory/ModifyRestockInventory", name: 'Edit Restock Inventory', auth: true },

    //Log
    "/admin/log/add": { page: "admin/log/ModifyLog", name: 'Add Log', auth: true },
    "/admin/log/view": { page: "admin/log/ViewLog", name: 'View Log', auth: true },
    "/admin/log/edit/:id": { page: "admin/log/ModifyLog", name: 'Edit Log', auth: true },

    //Analytics
    "/admin/analytics": { page: "admin/SiteAnalytics", name: 'Website Analytics', auth: true, role: 'admin' },
    "/flower-analytics": { page: "admin/FlowerAnalytics", name: 'Flower Analytics', auth: true },
    "/admin/strains/analytics": { page: "admin/strains/StrainAnalytics", name: 'Strain Analytics', auth: true },
    "/admin/strains/restock": { page: "admin/strains/StrainAnalytics", name: 'Strain Restock', auth: true },
    "/admin/recommendations": { page: "admin/strains/StrainCategories", name: 'Recommendations', auth: true },
}
